import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Icon = ({ icon }) => {
  if (!icon) return;
  return (
    <i>
      <FontAwesomeIcon icon={icon} />
    </i>
  );
};

export default Icon;
